@if (bookmark(); as pin) {
	<li class="d-flex justify-content-between my-2">
		<a [routerLink]="pin.url">
			<i class="menu-icon fas fa-thumbtack"></i>
			<span class="menu-bookmark pr-1">{{ pin.prefix | translate }} {{ pin.title }} </span>
		</a>
		<button type="button" class="menu-bookmark-delete far fa-times mr-3" (click)="remove.emit(pin)"></button>
	</li>
}